<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <!--            <strong  v-if="$route.params.product_id!=null">{{model_item_select.filter(x=>x.value==selected_model)[0].label}}</strong>-->
            <CRow>
              <CCol col="12">
                <CRow>
                  <CCol col="3" v-if="$route.params.product_id!=null">
                    <CSelect
                        :options="model_item_select"
                        :value.sync="selected_model"
                    />
                  </CCol>
                  <CCol col="3" v-else>
                    <!--                    <CSelect-->
                    <!--                        :options="model_item_select"-->
                    <!--                        :value.sync="selected_model"-->
                    <!--                    />-->
                    <treeselect
                        v-model="selected_model"

                        :async="async_product_search"
                        :options="input_products"
                        :load-options="load_products"
                        :placeholder="$t('components.searchProduct')"
                        :normalizer="normalizer_products"
                    />
                  </CCol>
                  <CCol col="2">
                    <select v-model="selected_place" class="form-control"

                    >
                      <option value="0">
                        {{ $t('components.selectWarehouse') }}
                      </option>
                      <option v-for="option in places_items" v-bind:value="option.id">
                        {{ option.placeName }}
                      </option>
                    </select>
                  </CCol>
                  <CCol col="2">
                    <select v-model="selected_type" class="form-control"

                    >
                      <option value="0">
                        {{ $t('all') }}
                      </option>
                      <option value="1">
                        {{ $t('output') }}
                      </option>
                      <option value="2">
                        {{ $t('input') }}
                      </option>

                    </select>
                  </CCol>
                  <CCol>
                    <date-picker
                        :label="$t('components.startDate')"
                        v-model="start_date"></date-picker>
                  </CCol>
                  <CCol>
                    <date-picker
                        :label="$t('components.endDate')"
                        v-model="end_date"></date-picker>
                  </CCol>
                </CRow>
              </CCol>

            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>

              <CCol col="3" style="font-weight: bold">
                {{ $t('INVValuation') }}: {{ exitType }}
              </CCol>
              <!--              <CCol col="3" style="direction: ltr;font-weight: bold">-->
              <!--                {{ $t('components.unitPrice') }}: {{ currency_symbol()-->
              <!--                }}{{get_currency(unit_price)}}-->
              <!--              </CCol>-->
              <CCol col="3" style="direction: ltr;font-weight: bold">
                {{ $t('components.existence') }}: {{
                  get_currency_no_fix(
                      parseInt((calculate_items(items.filter(x => x.sumExistance > 0), 'sumExistance')
                          + calculate_items(items.filter(x => x.sumExistance < 0), 'sumExistance')
                          + items[0].orginalExistance) / unit_value)
                  )
                }}
              </CCol>

            </CRow>
            <CDataTableFixed
                :items="items"
                :fields="fields"
                @row-clicked="table_row_clicked"
                border
                height="350px"

                striped
                hover

            >
              <template #row_id="{item,index}">

                <td :class="get_style(item)">
                  <p style="text-align: center">{{ index + 1 }}</p>
                </td>
              </template>
              <template #masterCode="{item}">
                <td :class="get_style(item)" style="text-align: center">
                  <a v-if="item.recId!=0" href="javascript:void(0)" class="text-primary"
                     v-on:click="goToDocuments(item)">
                    {{ item.masterCode }}
                  </a>
                </td>
              </template>
              <template #docTypeTitle="{item}">
                <td :class="get_style(item)">
                  <p v-if="item.recId!=0" style="text-align: center">{{ item.docTypeTitle }}</p>

                </td>
              </template>

              <template #price="{item}">
                <td :class="get_style(item)">
                  <p v-if="item.recId!=0 && item.porsant!=null">{{ item.customerPrice }}</p>

                </td>

              </template>
              <template #amount="{item}">
                <td>
                  <p v-if="item.recId!=0">{{ item.amount }}</p>
                </td>
              </template>
              <template #docDate="{item}">
                <td>
                  <p v-if="item.recId!=0" style="text-align: center">{{ get_date(item.docDate) }}</p>
                </td>
              </template>
              <template #amountNegetive="{item}">
                <td>
                  <p style="text-align: right">{{ item.amountNegetive }}</p>
                </td>
              </template>
              <template #accBalance="{item}">
                <td>
                  <p style="text-align: right">{{ item.accBalance }}</p>
                </td>
              </template>
              <template #accBalanceNegetive="{item}">
                <td>
                  <p style="text-align: right">{{ item.accBalanceNegetive }}</p>
                </td>
              </template>

              <template #kardexAccTypeTitle="{item}">
                <td>
                  <p>{{ item.kardexAccTypeTitle }}</p>
                </td>
              </template>
              <template #sumExistanceP="{item}">
                <td>
                  <p style="text-align: right" v-if="item.sumExistance>0">{{
                      get_currency_no_fix(item.sumExistance)
                    }}</p>
                  <p style="text-align: right" v-else>0</p>
                </td>
              </template>
              <template #sumExistanceN="{item}">
                <td>
                  <p style="text-align: right" v-if="item.sumExistance<=0">
                    {{ get_currency_no_fix(Math.abs(item.sumExistance)) }}</p>
                  <p style="text-align: right" v-else>0</p>

                </td>
              </template>
              <template #sumAmountP="{item}">
                <td>
                  <p style="text-align: right" v-if="item.sumAmount>0">{{ item.sumAmount }}</p>
                  <p style="text-align: right" v-else>0</p>

                </td>
              </template>

              <template #sumAmountN="{item}">
                <td>
                  <p style="text-align: right" v-if="item.sumAmount<=0">{{ Math.abs(item.sumAmount) }}</p>
                  <p style="text-align: right" v-else>0</p>
                </td>
              </template>
              <template #sell_price="{item}">

                <td :class="get_style(item)">
                  <p v-if="item.porsant!=null">{{ item.salePrice }}</p>

                </td>

              </template>
              <template #docDate="{item}">

                <td :class="get_style(item)">
                  <p v-if="item.recId!=0" style="text-align: center">{{ get_date(item.docDate) }}</p>

                </td>

              </template>
              <template #partyName="{item}">

                <td :class="get_style(item)">
                  <p v-if="item.recId!=0">{{ item.partyName }}</p>
                  <p v-if="item.recId==0">{{ $t('balanceBefore') }}</p>

                </td>

              </template>


              <template #orginalExistance="{item}">

                <td :class="get_style(item)">
                  <p style="text-align:right;padding-inline-start: 10px">{{ get_currency(item.orginalExistance) }}</p>

                </td>

              </template>
              <template #sumExistance="{item}">

                <td :class="get_style(item)">
                  <p style="padding-inline-start: 10px">{{ get_currency_no_fix(item.sumExistance) }}</p>

                </td>

              </template>
              <template #placeName="{item}">

                <td :class="get_style(item)">
                  <p style="padding-inline-start: 10px">{{ item.placeName }}</p>

                </td>

              </template>


              <template #operation="{item}">
                <td>


                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      :title="$t('buttons.show')"
                      size="sm"
                      @click="goShowDocument(item)"
                  >
                    <CIcon size="sm" name="cil-speedometer"/>
                  </CButton>


                </td>
              </template>
              <template #caption>
                <tr class="total-table">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ $t('totalCirculation') }}</td>
                  <td>{{ get_currency(total_input, 2) }}</td>
                  <td>{{ get_currency(total_output, 2) }}</td>
                  <td>{{ get_currency(total_existence) }}</td>

                </tr>

              </template>


            </CDataTableFixed>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];
import InputTag from 'vue-input-tag'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}

export default {
  name: 'Login',
  props: {
    models: Array,
    product_master_name: String
  },
  components: {
    InputTag,
    Treeselect
  },
  data() {
    return {
      total_input: '',
      total_output: '',
      total_existence: '',
      VUE_APP_Weight: localStorage.getItem('weight'),
      selected_model: null,
      name: '',
      file: '',
      start_date: '',
      end_date: '',
      color: '#ffffff',
      previewImage: '',
      selected_type: 0,
      selected_locations: ["A 114"],
      selected_template: 0,
      description: '',
      search_text: '',
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      selected_place: 0,
      places_items: [],
      async_product_search: true,
      input_products: [],
      fields: [


        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%;text-align:center;'},

        {key: 'docDate', label: this.$t('date'), _style: 'width:10%'},
        {key: 'masterCode', label: this.$t('ref'), _style: 'width:7%'},
        {key: 'partyName', label: this.$t('supplier_customer'), _style: 'width:20%'},

        {key: 'sumExistanceP', label: this.$t('income_qty'), _style: 'width:10%'},
        {key: 'sumExistanceN', label: this.$t('outgoing_qty'), _style: 'width:10%'},
        {key: 'orginalExistance', label: this.$t('stockQty'), _style: 'width:10%'},


      ],
      details: [],
      templates_items: [],
      collapseDuration: 0,
      model_items: [],
      status_form: 0,
      table_clicks: null,
      unit_price: '',
      exitType: '',
      unit_value: 1,
      table_clicks_timer: null,
      load_products({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,

        }
      },
    }
  },
  computed: {
    model_item_select() {
      // this.model_items=
      // this.model_items =

      var arr = this.sort_array([{label: this.$t('selectProduct'), value: 0}],
          this.models.filter(x => x.productId != null)
          , "productId", "model");
      // item_code
      console.log("models issss", arr)
      arr.forEach(function (val) {
        if (val.item_code != null) {
          val.label = val.item_code + " " + val.model

        }
      })
      return arr
    },
  },
  mounted() {
    if (this.$route.params.productid != null) {
      var data = this.$route.params;
      this.async_product_search = false;

      this.models.push({model: data.product_name, productId: data.productid})
      this.input_products = [{id: data.productid, productCodeName: data.product_name}]

      this.selected_model = data.productid
      this.start_date = data.start_date;
      this.end_date = data.end_date
      setTimeout(() => {
        this.async_product_search = true;

      }, 1000);

    }
    this.$root.root_validate_errors = [];
    this.start_date = this.get_day_before_today(6);
    this.end_date = this.get_today();
    this.get_places();
    bus.$on("product_cardex_selected", (data) => {
      // alert(data);
      this.table_clicks_timer = setTimeout(() => {
        this.models.push({model: data.label, productId: data.productId})
        this.selected_model = data.productId
        this.start_date = data.start_date;
        this.end_date = data.end_date
      }, 500);

    });
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });


  },
  watch: {
    'start_date': function () {
      this.get_lists();
    },
    'end_date': function () {
      this.get_lists();
    },
    'selected_place': function () {
      this.get_lists();
    },
    'selected_model': function () {
      if (this.selected_model != 0 && this.selected_model != null) {
        this.get_lists();
      }
    },
    'models': function () {
      if (this.models.length > 1) {
        console.log("models is", this.models)
        // this.selected_model = this.models[1].productId;
        if (this.$route.params.product_id != null) {
          // console.log("route product id is ",this.$route.params.productid)
          this.selected_model = parseInt(this.$route.params.product_id);

        }
      }
    },
    'selected_type': function () {
      if (this.selected_type == 0) {
        this.items = this.templates_items;

      }
      if (this.selected_type == 1) {
        this.items = this.templates_items.filter(item => item.sumExistance < 0);

      }
      if (this.selected_type == 2) {
        this.items = this.templates_items.filter(item => item.sumExistance > 0);

      }

      this.items = this.items.map((item, row_id) => {
        return {...item, row_id}
      });

    }
  },
  methods: {
    goToDocuments(item) {
      window.open('/dashboard/documents/show/' + item.masterId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);

        this.goShowDocument(item);
      }

    },
    get_style(item) {
      if (item.recId == 0) {
        return 'bg-success';
      } else if (item.docType == 10) {
        return 'bg-secondary';
      } else {
        return '';

      }


    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.masterId});
    },
    get_places() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetPlaces', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.places_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },

    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].unitName;
      this.color = this.items[item.row_id].color;
      this.description = this.items[item.row_id].description;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_sum_existance(list) {
      var sum = 0;
      list.forEach((val) => {
        sum += val.sumExistance;
      })
      return sum;
    },
    get_lists() {
      if (this.selected_model == null) {
        return
      }
      var self = this;
      //

      const formData = new FormData();

      var url = "GetCurrentExistance";

      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);
      formData.append('ProductId', this.selected_model);
      formData.append('Place', this.selected_place);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.total_input = 0
          self.total_output = 0
          self.total_existence = 0
          var before_balance = self.items.filter(x => x.recId == 0)[0].orginalExistance
          self.items.forEach(function (val, index) {
            if (index != 0&&val.docType!=10) {
              val.orginalExistance = self.items[index - 1].orginalExistance + val.sumExistance
            }
            if (val.sumExistance > 0) {
              self.total_input += val.sumExistance
            } else {
              self.total_output += val.sumExistance
            }
            if (val.docType == 10) {
              self.total_input = val.orginalExistance
              self.total_output = 0
              before_balance = 0
            }
          })
          self.total_existence = self.total_input +
              self.total_output +
              parseInt(before_balance);

          self.templates_items = content_data.data;
          // self.total_input = self.calculate_items(self.items.filter(x => x.sumExistance > 0), "sumExistance")}}</td>
          // self.total_output = Math.abs(self.calculate_items(self.items.filter(x => x.sumExistance < 0), "sumExistance")), 2)}}</td>
          // <td>{{get_currency(calculate_items(items.filter(x => x.sumExistance > 0), "sumExistance") + calculate_items(items.filter(x => x.sumExistance < 0), "sumExistance") + parseInt(items.filter(x => x.recId == 0)[0].orginalExistance),2)}}</td>

          // self.total_input
          // self.total_output
          // self.total_existence
          self.get_unit_price();
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_unit_price() {
      var self = this;
      //


      const formData = new FormData();

      var url = "GetLastProductPrice";

      // formData.append('Id', this.selected_product);
      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);
      formData.append('Id', this.selected_model);
      formData.append('Place', this.selected_place);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.unit_price = content_data.data.unitPrice;
          self.exitType = content_data.data.exitType;
          self.unit_value = content_data.data.unitValue;
          // self.templates_items = content_data.data;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditProduct(item, index) {

      this.$router.push({path: '/dashboard/products/edit/' + this.items[index].id});
      // this.$router.push({route_name: 'create_product' });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    }, goEditProductPrice(item, index) {

      this.$router.push({path: '/dashboard/products/edit-price/' + this.items[index].id});
      // this.$router.push({route_name: 'create_product' });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteProduct";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
